import { useMemo, type SyntheticEvent } from 'react';

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

export interface TimezoneOption {
  value: string;
  label: string;
}

interface TimezoneAutocompleteNzAuProps {
  value: string | null | undefined;
  onChange: (event: SyntheticEvent, value: TimezoneOption | null) => void;
  label?: string;
  required?: boolean;
  error?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
}

const timezoneOptions: TimezoneOption[] = Intl.supportedValuesOf('timeZone')
  .filter((timeZone) => timeZone.startsWith('Australia/') || timeZone === 'Pacific/Auckland' || timeZone.startsWith('Pacific/Chatham'))
  .map((timeZone) => ({ value: timeZone, label: timeZone }));

const TimezoneAutocompleteNzAu = ({
  value,
  onChange,
  label = 'Timezone',
  required = false,
  error = false,
  fullWidth = true,
  disabled = false
}: TimezoneAutocompleteNzAuProps) => {
  const selectedOption = useMemo(() => timezoneOptions.find((tz) => tz.value === value) || null, [value]);

  return (
    <Autocomplete
      options={timezoneOptions}
      isOptionEqualToValue={(option, optionValue) => option?.value === optionValue?.value}
      getOptionLabel={(option) => option?.label || ''}
      value={selectedOption}
      onChange={onChange}
      disabled={disabled}
      fullWidth={fullWidth}
      renderInput={(params) => <TextField {...params} label={label} required={required} error={error} />}
    />
  );
};

export default TimezoneAutocompleteNzAu;
